import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function formLogout() {
  window.localStorage.setItem('activeMyTodoToggle', false);
  return dispatchCommand('FormLogout');
}
